/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect } from 'react';
import { createContext, PropsWithChildren } from 'react';
import { usePhoneActions } from '../use-phone';
import { DesktopMessage, DesktopMessageStartCall, DesktopMessageStartContactCall, useDesktop } from '@revenuewell/logic-desktop';
import { useContact } from '@revenuewell/logic-contact';

export const PhoneEventHandlerContext = createContext(null!);

export const PhoneEventHandlerProvider = ({ children }: PropsWithChildren<{}>) => {
  const { call } = usePhoneActions();
  const { isDesktopWidget, listenMessage, showWindow } = useDesktop();
  const { getContactDetailsById } = useContact();

  useEffect(() => {
    if (isDesktopWidget) {
      const unsubscribe = [
        listenMessage('desktop-start-call', (data: DesktopMessage) => {
          const { payload } = data as DesktopMessageStartCall;
          call(payload.number.toString());
          setTimeout(() => showWindow(), 1300);
        }),
        listenMessage('desktop-start-call-contact', (data: DesktopMessage) => {
          const { payload } = data as DesktopMessageStartContactCall;
          startContactCall(payload.contactId);
          setTimeout(() => showWindow(), 1300);
        })
      ];

      return () => unsubscribe.forEach((u) => u());
    }
  }, [call]);

  const startContactCall = async (contactId: string | number) => {
    const contact = await getContactDetailsById(contactId as number);
    if (contact && contact.cellPhone) call(contact.cellPhone);
    else console.log('CONTACT PHONE CALL -> contact is not found. ContactId: ', contactId);
  };

  return <PhoneEventHandlerContext.Provider value={null!}>{children}</PhoneEventHandlerContext.Provider>;
};
